export const GET_ROLES_START = "GET_ROLES_START";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_FAILURE = "GET_ROLES_FAILURE";

export const ASSIGN_PERMISSIONS_START = "ASSIGN_PERMISSIONS_START";
export const ASSIGN_PERMISSIONS_SUCCESS = "ASSIGN_PERMISSIONS_SUCCESS";
export const ASSIGN_PERMISSIONS_FAILURE = "ASSIGN_PERMISSIONS_FAILURE";

export const CREATE_ROLE_START = "CREATE_ROLE_START";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAILURE = "CREATE_ROLE_FAILURE";

export const UPDATE_ROLE_START = "UPDATE_ROLE_START";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAILURE = "UPDATE_ROLE_FAILURE";

export const GET_ASSIGNED_PERMISSIONS_START = "GET_ASSIGNED_PERMISSIONS_START";
export const GET_ASSIGNED_PERMISSIONS_SUCCESS = "GET_ASSIGNED_PERMISSIONS_SUCCESS";
export const GET_ASSIGNED_PERMISSIONS_FAILURE = "GET_ASSIGNED_PERMISSIONS_FAILURE";
